import { QueryClient } from '@tanstack/react-query';
import { setQueryClient } from './api/client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30000,
    },
  },
});

setQueryClient(queryClient);
